var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hint)?_c('div',{staticClass:"flex items-center font-medium"},[_c('span',{staticClass:"text-black-01 text-base leading-4.5"},[_vm._v("/")]),_c('span',{staticClass:"text-black-01 text-xs leading-normal"},[_vm._v(_vm._s(_setup.hint))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }